<template>
  <!-- 课程上传  -->
  <div class="Materialtoupload">
    <div class="box">
      <div class="tbox-top">
        <!-- <h4 class="scsc">课程上传</h4> -->
        <div style="display: flex; align-items: center; height: 20px">
          <span style="font-size: 13px; color: #333; font-weight: 500"
            >筛选 ：</span
          >
          <el-select
            @change="selmaterialis()"
            v-model="value"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="ssssc" @click="Alltheupload()">全部上传</div>
        <div class="deleta" @click="delmatess()">全部删除</div>
        <!-- <div class="searchbox">
          <el-input placeholder="请输入内容" size="mini" v-model="name">
            <template slot="append"
              ><el-button @click="selmaterialis()" round
                >搜索</el-button
              ></template
            >
          </el-input>
        </div> -->
      </div>
      <ul style="margin-top: 30px">
        <li
          :class="[
            item.status === '已保存' || item.status === '驳回'
              ? 'wzts'
              : 'scscxsk',
          ]"
          v-for="item in formInline"
          :key="item.id"
        >
          <video
            @click="item.status === '已通过' ? jump(item) : null"
            :src="http + item.sp"
            controls
          ></video>

          <div class="text">
            <h4>{{ item.name }}</h4>
            <p v-html="item.kcjs"></p>
            <div class="smis">
              <span v-if="item.status === '已发布'"
                >通过时间：{{ item.itemtime }}</span
              >
              <span v-if="item.status === '已保存'"
                >保存时间：{{ item.itemtime }}</span
              >
              <span v-if="item.status === '待发布'"
                >文件上传时间：{{ item.itemtime }}</span
              >
              <span v-if="item.status === '已驳回'"
                >驳回时间：{{ item.itemtime }}</span
              >
            </div>
          </div>

          <div class="right-bottom">
            <span v-if="item.status === '已发布'" class="sadda saddsa">
              已通过</span
            >
            <span v-if="item.status === '已保存'" class="sadda saddsa2">
              {{ item.status }}</span
            >
            <span v-if="item.status === '待发布'" class="sadda saddsa1">
              审批中
            </span>
            <span
              v-if="item.status === '已驳回'"
              class="sadda saddsa3"
              @click="dialogVisiblebhss(item, '已驳回')"
            >
              {{ item.status }}(查看)
            </span>
            <span
              v-if="item.status === '已撤回'"
              class="sadda saddsa3"
              @click="dialogVisiblebhss(item, '已撤回')"
            >
              {{ item.status }}(查看)
            </span>
            <el-button
              v-if="
                item.status == '已保存' ||
                item.status == '已驳回' ||
                item.status == '已撤回'
              "
              class="sch"
              style="margin: 10% 0"
              type="danger"
              @click="delmaterial(item)"
              >删除</el-button
            >
            <el-button
              v-if="item.status == '已发布'"
              class="sch"
              style="margin: 10% 0"
              type="danger"
              @click="snnnajnsd(item)"
              >撤回</el-button
            >
            <!-- <el-button
              class="lasez"

              type="primary"
              @click="submitForm(item)"
              >保存</el-button
            > -->
            <!-- <el-button
              class="lasez"
              v-if="item.status === '驳回'"
              type="primary"
              @click="sssubmitForm(item)"
              >保存</el-button
            > -->
            <el-button
              class="lasez"
              type="primary"
              @click="$router.push(`/Coursedetails/${item.id}`)"
              >详细信息</el-button
            >
            <el-button
              v-if="
                item.status === '已保存' ||
                item.status === '已驳回' ||
                item.status === '已撤回'
              "
              class="lasez"
              style="margin: 10% 0"
              type="primary"
              @click="Fileupload(item)"
              >提交课程</el-button
            >
          </div>
        </li>
      </ul>
      <el-dialog
        title="撤回原因"
        :visible.sync="dialogssdaqwVisible"
        width="30%"
        ><el-input
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="bhyyys"
        >
        </el-input>

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogssdaqwVisible = false">取 消</el-button>
          <el-button type="primary" @click="chehuidssch()">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
        class="dialogbhuyuan"
        :title="btiskk"
        :visible.sync="dialogVisiblebh"
        width="25%"
      >
        <p>{{ bhyys }}</p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
        </span>
      </el-dialog>
      <el-pagination
        class="paging"
        background
        prev-text="上一页"
        next-text="下一页"
        @current-change="handleCurrentChangess"
        :page-size="tepage.rows"
        layout="prev, pager, next"
        :total="tepage.total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import {
  selusersc,
  delitem,
  seluseritem,
  selsort,
  delmaterial,
  updmaterialsp,
  updmaterial,
  upditemsp,
} from "../../../api/patient";
export default {
  data() {
    return {
      bhyyyid: "",
      bhyyys: "",
      dialogssdaqwVisible: false,
      http: this.$store.state.https,
      name: "",
      tepage: {
        page: 1,
        rows: 5,
        total: 100,
      },
      Majorcategories: "",
      value: "全部",
      btiskk: "",
      options: [
        {
          value: "全部",
          label: "全部",
        },
        {
          value: "已保存",
          label: "已保存",
        },
        {
          value: "待发布",
          label: "审批中",
        },
        {
          value: "已发布",
          label: "已通过",
        },
        {
          value: "已驳回",
          label: "已驳回",
        },
        {
          value: "已撤回",
          label: "已撤回",
        },
      ],
      formInline: [],
      rules: {},
      dialogVisiblebh: false,
      bhyys: "",
    };
  },
  created() {
    // if (this.$store.state.ybcs !== 1) { this.value = this.$store.state.ybcs }
    this.selmaterialis();
    this.selsortis();
  },
  methods: {
    snnnajnsd(item) {
      (this.bhyyyid = item.id), (this.dialogssdaqwVisible = true);
    },

    chehuidssch() {
      if (this.bhyyys !== "" && this.bhyyys !== null) {
        var data = new FormData();
        data.append("ids", this.bhyyyid);
        data.append("status", "已撤回");
        data.append("bhyy", this.bhyyys);
        upditemsp(data).then((res) => {
          console.log(res);
          if (res.code === "OK") {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "success",
            });
            this.dialogssdaqwVisible = false;
            this.selmaterialis();
          }
        });
      } else {
        this.$message({
          showClose: true,
          message: "请填写完整",
          type: "warning",
        });
      }
    },
    uploadmaterial() {
      if (this.$store.state.isLogin) {
        this.$router.push("/Courseupload");
      } else {
        this.$message({
          showClose: true,
          message: "请先进行登录",
          type: "warning",
        });
      }
    },
    handleClose() {
      this.dialogVisiblebh = false;
      this.bhyys = "";
    },
    dialogVisiblebhss(item, i) {
      if (i === "已驳回") {
        this.btiskk = "驳回原因";
      } else {
        this.btiskk = "撤回原因";
      }

      this.dialogVisiblebh = true;
      this.bhyys = item.bhyy;
    },
    // 上传全部
    async Alltheupload(formName) {
      // debugger;
      var s = 0;
      var a = [];
      for (let i = 0; i < this.formInline.length; i++) {
        if (
          this.formInline[i].sort !== "" &&
          this.formInline[i].sort !== null &&
          this.formInline[i].name !== "" &&
          this.formInline[i].name !== null &&
          this.formInline[i].kcjs !== "" &&
          this.formInline[i].kcjs !== null &&
          this.formInline[i].sp !== "" &&
          this.formInline[i].sp !== null &&
          this.formInline[i].wslzyzd !== "" &&
          this.formInline[i].wslzyzd !== null
        ) {
          var data = new FormData();
          data.append("id", this.formInline[i].id);
          data.append("sort", this.formInline[i].sort);
          data.append("name", this.formInline[i].name);
          data.append("kcjs", this.formInline[i].kcjs);
          data.append("sp", this.formInline[i].sp);
          if (
            this.formInline[i].tp1 !== "" &&
            this.formInline[i].tp1 !== null
          ) {
            data.append("tp1", this.formInline[i].tp1);
          } else {
            data.append("tp", this.formInline[i].tp);
          }
          data.append("userid", this.$store.state.user.id);
          await upditem(data).then((res) => {
            a.push(this.formInline[i].id);
            if (i === this.formInline.length - 1) {
              s = 1;
            }
          });
        } else {
          this.$message({
            message: "请填写完整后，并保存成功后点击全部提交",
            type: "warning",
          });
          return;
        }
      }
      if (s == 1) {
        var data = new FormData();
        data.append("ids", a);
        data.append("status", "待发布");
        upditemsp(data).then((res) => {
          if (res.code === "OK") {
            this.$message({
              showClose: true,
              message: res.msg,
              type: "success",
            });
            this.selmaterialis();
          }
        });
      }
    },
    // async Alltheupload() {
    //   var isss = 0;
    //   const set = []; // set 自带去重
    //   for (let s = 0; s < this.formInline.length; s++) {
    //     if (this.formInline[s].status === "已保存") {
    //       var datas = new FormData();
    //       datas.append("id", this.formInline[s].id);
    //       datas.append("scwj", this.formInline[s].scwj);
    //       datas.append("scmc", this.formInline[s].scmc);
    //       datas.append("scgs", this.formInline[s].scgs);
    //       datas.append("sccc", this.formInline[s].sccc);
    //       datas.append("wjgs", this.formInline[s].wjgs);
    //       datas.append("sort", this.formInline[s].sort);
    //       await updmaterial(datas).then((res) => {});
    //       if (!set.includes(this.formInline[s].id)) {
    //         set.push(this.formInline[s].id);
    //       }
    //     }
    //   }
    //   for (let l = 0; l < this.formInline.length; l++) {
    //     if (
    //       this.formInline[l].sort === "" ||
    //       this.formInline[l].sort === null ||
    //       this.formInline[l].scmc === "" ||
    //       this.formInline[l].scmc === null
    //     ) {
    //       isss++;
    //       this.$message({
    //         showClose: true,
    //         message: "请填写完整",
    //         type: "warning",
    //       });
    //       return;
    //     }
    //   }
    //   if (isss === 0) {
    //     var data = new FormData();
    //     data.append("ids", set);
    //     data.append("status", "审批中");
    //     await upditemsp(data).then((res) => {
    //       console.log(res);
    //       if (res.code === "OK") {
    //         this.$message({
    //           showClose: true,
    //           message: "上传成功",
    //           type: "success",
    //         });
    //         this.selmaterialis();
    //       }
    //     });
    //   }
    // },
    // 跳转
    jump(item) {
      // this.$router.push("/materialdetailspage");
      $router.push(`/Coursedetails/:${item}`);
    },
    // 文件保存
    submitForm(iten) {
      if (iten.scmc) {
        if (iten.sort) {
          var data = new FormData();
          data.append("id", iten.id);
          data.append("scwj", iten.scwj);
          data.append("scmc", iten.scmc);
          data.append("scgs", iten.scgs);
          data.append("sccc", iten.sccc);
          data.append("wjgs", iten.wjgs);
          data.append("sort", iten.sort);
          updmaterial(data).then((res) => {
            console.log(res);
            if (res.code === "OK") {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }

            this.selmaterialis();
          });
        } else {
          this.$message({
            showClose: true,
            message: "请选择文件类型",
            type: "warning",
          });
        }
      } else {
        this.$message({
          showClose: true,
          message: "请填写文件标题",
          type: "warning",
        });
      }
    },
    // 文件保存
    sssubmitForm(iten) {
      if (iten.scmc) {
        if (iten.sort) {
          var data = new FormData();
          data.append("id", iten.id);
          data.append("scwj", iten.scwj);
          data.append("scmc", iten.scmc);
          data.append("scgs", iten.scgs);
          data.append("sccc", iten.sccc);
          data.append("wjgs", iten.wjgs);
          data.append("sort", iten.sort);
          updmaterial(data).then((res) => {
            console.log(res);
            if (res.code === "OK") {
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
            this.Fileuploadsss(iten);
          });
        } else {
          this.$message({
            showClose: true,
            message: "请选择文件类型",
            type: "warning",
          });
        }
      } else {
        this.$message({
          showClose: true,
          message: "请填写文件标题",
          type: "warning",
        });
      }
    },
    async Fileuploadsss(item) {
      if (item.scmc) {
        if (item.sort) {
          var data = new FormData();
          data.append("ids", item.id);
          data.append("status", "已保存");
          await updmaterialsp(data).then((res) => {
            console.log(res);
            if (res.code === "OK") {
              this.selmaterialis();
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: "请选择文件类型",
            type: "warning",
          });
        }
      } else {
        this.$message({
          showClose: true,
          message: "请填写文件标题",
          type: "warning",
        });
      }
    },
    // 文件上传
    async Fileupload(item) {
      console.log(item);
      var data = new FormData();
      data.append("ids", item.id);
      data.append("status", "待发布");
      upditemsp(data).then((res) => {
        if (res.code === "OK") {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "success",
          });
          this.selmaterialis();
        }
      });
    },
    // 全部删除
    delmatess() {
      const set = []; // set 自带去重
      for (let s = 0; s < this.formInline.length; s++) {
        if (!set.includes(this.formInline[s].id)) {
          set.push(this.formInline[s].id);
        }
      }
      console.log(set);
      var data = new FormData();
      data.append("ids", set);
      delitem(data).then((res) => {
        if (res.code === "OK") {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "success",
          });
          this.selmaterialis();
        }
      });
    },
    // 删除
    delmaterial(item) {
      var data = new FormData();
      data.append("ids", item.id);
      delitem(data).then((res) => {
        console.log(res);
        if (res.code === "OK") {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "success",
          });
          this.selmaterialis();
        }
      });
    },
    // 筛选大类
    selsortis() {
      var data = new FormData();
      data.append("page", 1);
      data.append("rows", 100);
      selsort(data).then((res) => {
        this.Majorcategories = res.rows;
      });
    },
    // 列表
    selmaterialis() {
      var data = new FormData();
      data.append("page", this.tepage.page);
      data.append("rows", this.tepage.rows);
      data.append("userid", this.$store.state.user.id);
      if (this.name) {
        data.append("name", this.name);
      }
      if (this.value === "全部") {
      } else {
        data.append("status", this.value);
      }
      seluseritem(data).then((res) => {
        console.log(res);
        this.formInline = res.rows;
        this.tepage.total = res.total;
      });
    },
    handleCurrentChangess(val) {
      this.tepage.page = val;
      this.selmaterialis();
    },
  },
  beforeDestroy() {
    // this.$store.commit('Stateofsss', 1)
  },
};
</script>
<style lang="scss" scoped>
.Materialtoupload {
  .box {
    .tbox-top {
      display: flex;
      margin-bottom: 15px;
      .scsc {
        font-size: 16px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
        line-height: 40px;
        margin-right: 26px;
      }
      h2 {
        line-height: 40px;
        //   margin-right: 16px;
      }

      .el-select {
        line-height: 40px;
        width: 100px;
        ::v-deep .el-input__inner {
          border: 1px solid #4ccaff;
          height: 30px;
        }
      }
    }
    .scscxsk {
      cursor: pointer;
      display: flex;
      margin-bottom: 10px;
    }
    .wzts {
      cursor: pointer;
      text-align: left;
      width: 770px;
      height: 151px;
      background: #ffffff;
      border: 1px solid #f0f0f0;
      box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.22);
      border-radius: 6px;
      display: flex;
      margin-bottom: 10px;
      video {
        width: 268px;
        height: 151px;

        opacity: 0.9;
        border-radius: 6px;
        line-height: 151px;
      }
      img {
        width: 268px;
        height: 151px;
        opacity: 0.8;
        border-radius: 6px;
      }
      .certer {
        padding: 0 20px;
      }
    }
  }
}
.searchbox {
  line-height: 40px;

  width: 255px;
  ::v-deep .el-input__inner {
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    // border-top-right-radius: 15px;
    // border-bottom-right-radius: 15px;
  }
  ::v-deep .el-input-group__append {
    margin-left: 100px;
    // line-height: 30px;
    border: 0px;
    background: #fff;

    .el-button {
      position: relative;
      left: -10px;
      top: -1px;
      padding: 0px;
      width: 70px;
      height: 30px;
      background: #4ccaff;
      border: 1px solid #ededed;
      border-radius: 15px;
      color: #fff;
    }
  }
}
.deleta {
  // line-height: 40px;
  font-size: 13px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #fb4747;
  cursor: pointer;
  // margin-left: 18px;
  margin-right: 30px;
}

.scscxsk {
  text-align: left;
  width: 770px;
  height: 151px;
  background: #ffffff;
  border: 1px solid #f0f0f0;
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.22);
  border-radius: 6px;
  transition: all 0.2s;
  video {
    width: 268px;
    height: 151px;

    opacity: 0.9;
    border-radius: 6px;
    line-height: 151px;
  }
  img {
    width: 268px;
    height: 151px;
    opacity: 0.8;
    border-radius: 6px;
  }
  .certer {
    padding: 0 20px;
  }
}
.scscxsk:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
}
.right-bottom {
  display: flex;
  flex-direction: column;
  width: 76px;
  padding-right: 20px;
  button {
    margin: 0px;
    padding: 0;
    width: 76px;
    height: 28px;
    border-radius: 6px;
    border: 0;
  }
  .lasez {
    background: #4ccaff;
  }
  .lasez:hover {
    background: #4ccaffc9;
  }
  .sch:hover {
    background: #f56c6cc7;
  }
}

ul {
  padding-bottom: 50px;
}
.boytrtr {
  text-align: center;
  .el-button {
    padding: 0;
    width: 99px;
    height: 28px;
    background: #4ccaff;
    border-radius: 6px;
    border: 0px;
  }
}
.el-button:hover {
  background: #4ccaffc9;
}
.demo-form-s {
  width: 403px;
  margin-left: 16px;
  margin-right: 8px;
  margin-top: 18px;
  .el-form-item {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #ff1818;
    // line-height: 44px;
  }
}
.smis {
  text-align: center;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #666666;
  // line-height: 44px;
}
ul {
  min-height: 700px;
}

.paging {
  margin-bottom: 70px;
}
.sadda {
  margin: 20% 0px;
  font-size: 12px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  text-align: center;
}
.saddsa {
  // 通过

  color: #00c92f;
}
.saddsa1 {
  // 审批

  color: #4ccaff;
}
.saddsa2 {
  // 保存

  color: #666666;
}
.saddsa3 {
  // 驳回

  color: #fb4747;
}
.ssssc {
  // line-height: 40px;
  font-size: 13px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #4ccaff;
  cursor: pointer;
  margin-left: 450px;
  margin-right: 30px;
}
.el-button:hover {
  background: #4ccaffc9;
}
.el-pagination {
  ::v-deep button {
    padding: 0 5px;
  }
}
.dialogbhuyuan {
  text-align: left;
  p {
    padding-left: 20px;
  }
}
.el-pagination {
  ::v-deep span {
    padding: 0 10px;
  }
}
img {
  object-fit: contain;
}
.text {
  border: none;
  margin-left: 18px;
  margin-right: 30px;
  display: flex;
  flex-direction: column;
  h4 {
    margin-top: 20px;
    margin-bottom: 10px;
    width: 350px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  p {
    width: 350px;
    height: 60px;
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 20px;
    color: #333333;

    overflow: hidden;

    text-overflow: ellipsis;

    display: -webkit-box;

    -webkit-line-clamp: 3;

    word-break: break-all;

    -webkit-box-orient: vertical;
  }
  .smis {
    margin-top: 10px;
    display: flex;
    div {
      margin-right: 70px;
    }
  }
}

// 适配手机端
@media (max-width: 768px) {
  .Materialtoupload {
    .box {
      .tbox-top {
        span {
          display: block;
          width: 50px;
          z-index: 1;
        }
      }
      .scscxsk {
        cursor: pointer;
        display: block;
        margin-bottom: 10px;
      }
      .wzts {
        width: 90vw;
        height: 420px;
        display: flex;
        flex-wrap: wrap;
        video {
          width: 80vw;
          margin-left: 5vw;
          margin-top: 10px !important;
        }
        img {
          width: 80vw;
          margin-left: 5vw;
          margin-top: 10px !important;
        }
        .certer {
          padding: 0 20px;
        }
      }
    }
  }
  .searchbox {
    line-height: 40px;

    width: 255px;
    ::v-deep .el-input__inner {
      border-top-left-radius: 15px;
      border-bottom-left-radius: 15px;
      // border-top-right-radius: 15px;
      // border-bottom-right-radius: 15px;
    }
    ::v-deep .el-input-group__append {
      margin-left: 100px;
      // line-height: 30px;
      border: 0px;
      background: #fff;

      .el-button {
        position: relative;
        left: -10px;
        top: -1px;
        padding: 0px;
        width: 70px;
        height: 30px;
        background: #4ccaff;
        border: 1px solid #ededed;
        border-radius: 15px;
        color: #fff;
      }
    }
  }
  .deleta {
    // line-height: 40px;
    font-size: 13px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #fb4747;
    cursor: pointer;
    // margin-left: 18px;
    margin-right: 30px;
  }

  .scscxsk {
    text-align: left;
    width: 90vw;
    height: 420px;
    background: #ffffff;
    border: 1px solid #f0f0f0;
    box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.22);
    border-radius: 6px;
    transition: all 0.2s;

    video {
      width: 80vw;
      margin-left: 5vw;
      margin-top: 10px !important;
    }

    img {
      width: 80vw;
      margin-left: 5vw;
      margin-top: 10px !important;
    }

    .certer {
      padding: 0 20px;
    }
  }
  .scscxsk:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 20px 0 rgba(95, 101, 105, 0.15);
  }
  .right-bottom {
    display: flex;
    flex-direction: row-reverse;
    width: 80vw;
    align-items: center;
    padding-right: 20px;
    button {
      margin: 2px;
    }
    .lasez {
      background: #4ccaff;
    }
    .lasez:hover {
      background: #4ccaffc9;
    }
    .sch:hover {
      background: #f56c6cc7;
    }
  }

  ul {
    padding-bottom: 50px;
  }
  .boytrtr {
    text-align: center;
    .el-button {
      padding: 0;
      width: 99px;
      height: 28px;
      background: #4ccaff;
      border-radius: 6px;
      border: 0px;
    }
  }
  .el-button:hover {
    background: #4ccaffc9;
  }
  .demo-form-s {
    width: 403px;
    margin-left: 16px;
    margin-right: 8px;
    margin-top: 18px;
    .el-form-item {
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #ff1818;
      // line-height: 44px;
    }
  }
  .smis {
    text-align: center;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #666666;
    // line-height: 44px;
  }
  ul {
    min-height: 700px;
  }

  .paging {
    margin-bottom: 70px;
  }
  .sadda {
    margin: 0% 10px;
  }
  .saddsa {
    // 通过

    color: #00c92f;
  }
  .saddsa1 {
    // 审批

    color: #4ccaff;
  }
  .saddsa2 {
    // 保存

    color: #666666;
  }
  .saddsa3 {
    // 驳回

    color: #fb4747;
  }
  .ssssc {
    margin-left: 40px;
  }
  .el-button:hover {
    background: #4ccaffc9;
  }
  .el-pagination {
    ::v-deep button {
      padding: 0 5px;
    }
  }
  .dialogbhuyuan {
    text-align: left;
    p {
      padding-left: 20px;
    }
  }
  .el-pagination {
    ::v-deep span {
      padding: 0 10px;
    }
  }
  img {
    object-fit: contain;
  }
  .text {
    border: none;
    margin-left: 18px;
    margin-right: 30px;
    display: flex;
    flex-direction: column;
    h4 {
      margin-top: 10px;
      width: 80vw;
    }
    p {
      width: 80vw;
    }
    .smis {
      margin-top: 10px;
      display: flex;
      div {
        margin-right: 70px;
      }
    }
  }
}
</style>
